import React, {useState} from "react"
import {MDBBtn, MDBContainer, MDBInput} from "mdb-react-ui-kit";
import {Typography, Alert} from "@mui/material";
import {useFormik} from "formik";
import * as Yup from 'yup';
import {useLocation, useNavigate} from 'react-router-dom';
import {postReset, ResetBody} from "../../services/auth_request"

interface ResetPasswordInputProps {
    email: string;
    password_1: string
    password_2: string
    code:string
}

export type DatosDestino = {
    email: string
};

export type LocationState = {
  datos?: DatosDestino;
};

const wait = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

const ResetPassword: React.FC = ()=>{
    const location = useLocation();
    const state = location.state as LocationState;
    const datos = state?.datos;
    const [mjs, setMjs] = useState('')
    const navigate = useNavigate()

    const formik = useFormik<ResetPasswordInputProps>({
        initialValues:{
            email: datos? datos.email: '',
            password_1:'',
            password_2:'',
            code: ''
        },
        validationSchema: Yup.object({
            password_1: Yup.string()
                .required('La contraseña es obligatoria')
                .min(8, 'La contraseña debe tener al menos 8 caracteres')
                .matches(
                    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    'Debe contener al menos una mayúscula, un número y un carácter especial (@$!%*?&)'
                ),
            password_2: Yup.string()
                .required('Debes confirmar tu contraseña')
                .oneOf([Yup.ref('password_1')], 'Las contraseñas no coinciden'),
            code: Yup.string()
            .required('El código es obligatorio')
            .matches(/^\d{6}$/, 'Debe contener exactamente 6 dígitos numéricos'),
        }),
        onSubmit: async (values)=>{
            if (values.password_1 === values.password_2 && datos){
                const body:ResetBody = {
                    email: datos.email,
                    password: values.password_2,
                    codigo: Number(values.code)
                }
                const response = await postReset(body)
                console.log(response)
                if (response === 200){
                    setMjs("se a cambiado su contraseña")
                    await wait(10000)
                    navigate('/login');

                }else{
                    setMjs('Error, el código no es valido o vuelve a intentarlo detro de 15 minutos')
                }
            }
        }

    })
    return<>
        {mjs !== '' && <Alert severity={'info'} color={'info'}>{mjs}</Alert>}
        <MDBContainer className="p-1 my-5 d-flex flex-column w-75">
            <form onSubmit={formik.handleSubmit}>
                <Typography fontWeight={700} variant='h5' textAlign={"center"}>Ingresa el código de recuperación</Typography>
                <Typography
                    variant='subtitle1'
                    textAlign={"center"}>
                    Hemos enviado un código de 6 dígitos a tu correo ({datos?.email}), este durará 15 minutos. Introdúcelo a continuación.
                </Typography>

                <MDBInput

                    wrapperClass='mb-1'
                    label='Code'
                    name='code'
                    id='code'
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    autoComplete={"off"}
                    value={formik.values.code}
                    type='text'
                    maxLength={6}
                />
                <MDBInput
                    wrapperClass='mb-2'
                    label='Password'
                    name='password_1'
                    id='password_1'
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    autoComplete={"new-password"}
                    type='password'
                    value={formik.values.password_1}
                />
                <MDBInput
                    wrapperClass='mb-2'
                    label='Password'
                    name='password_2'
                    id='password_2'
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    autoComplete={"new-password"}
                    type='password'
                    value={formik.values.password_2}
                />
                {formik.touched.password_1 && formik.errors.password_1 ? (
                    <Alert severity={'info'} color={'warning'}>{formik.errors.password_1}</Alert>
                ) : null}
                {formik.touched.password_2 && formik.errors.password_2 ? (
                    <Alert severity={'info'} color={'warning'}>{formik.errors.password_2}</Alert>
                ) : null}
                {formik.touched.code && formik.errors.code ? (
                    <Alert variant="standard" severity="error">{formik.errors.code} </Alert>
                ) : null}
                <MDBBtn className="mb-4" type='submit' disabled={!formik.isValid || !formik.dirty}>Recuperar</MDBBtn>
            </form>
        </MDBContainer>
    </>
}

export default ResetPassword